/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'IT-Footer-Links-eSpot_rv' },
    { emsName: 'IT-Footer-NewsLetter-eSpot_rv' },
    { emsName: 'IT-Footer-Payment-eSpot_rv' },
    { emsName: 'IT-Footer-Privacy-Links-espot-rv'},
    { emsName: 'IT-HTML-Banner-Styles-eSpot_rv' }
];
export default contentItems;
